type TMessageSender =
  | {
      user?: {
        firstName?: string
        lastName?: string
      } | null
    }
  | null
  | undefined

const getMessageSenderName = (createdBy: TMessageSender) => {
  const firstName = createdBy?.user?.firstName || ''
  const lastName = createdBy?.user?.lastName || ''
  const fullName = `${firstName} ${lastName}`.trim()

  if (fullName) {
    return fullName
  }

  return 'Unknown user'
}

export { getMessageSenderName }
